import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
import Swal from 'sweetalert2';
import { RestClientService } from '../../../core/service/rest-client.service';
import { AuthService } from '../../../core/service/auth.service';
import { UtilitiesService } from '../../../core/service/utilities.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { BenefInfoComponent } from '@shared/components/benef-info/benef-info.component';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { ScrollSearchMedocPrestaComponent } from '@shared/components/scroll-search-medoc-presta/scroll-search-medoc-presta.component';
import { PrestationInfoComponent } from '@shared/components/prestation-info/prestation-info.component';
import { SearchMdicamentProComponent } from '@shared/components/search-mdicament-pro/search-mdicament-pro.component';
import { ScrollSearchAffectionComponent } from '@shared/components/scroll-search-affection/scroll-search-affection.component';
import { SearchFormComponent } from '@shared/components/search-form/search-form.component';
// import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-form-ordonnance',
  standalone: true,
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    BenefInfoComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    FileUploadComponent,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatButtonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSlideToggleModule,
    ScrollSearchMedocPrestaComponent,
    BenefInfoComponent,
    PrestationInfoComponent,
    SearchMdicamentProComponent,
    ScrollSearchAffectionComponent,
    SearchFormComponent,
  ],
  templateUrl: './form-ordonnance.component.html',
  styleUrl: './form-ordonnance.component.css',
})
export class FormOrdonnanceComponent {
  selectedTab = 'tab1';
  @Output() onSendBenefItem = new EventEmitter<any>();
  @Output() onClosePrescriptionMedocModal = new EventEmitter<any>();
  @Output() onGoToTab = new EventEmitter<any>();
  @Input() matricule: any;
  cancelItemSelected = false;
  @Input() refreshTriggerOrdonnance!: boolean;

  current_medicament_id: any = '';
  reload = false;
  produit: string = '';
  clearText = false;
  selectedPosologie: string = '';
  selectedDetailItem: any = null;
  showPosologieSuggestions: boolean = false;
  posologieSuggestions: { text: string }[] = [];
  selectedSuggestionText: string = '';

  private readonly POSOLOGIE_MAP: Record<string, string[]> = {
    COMPRIMÉ: [
      '1 cp matin et soir pendant {duree} jours',
      '1 cp matin, midi et soir pendant {duree} jours',
      '2 cp matin et soir pendant {duree} jours',
      '1/2 cp matin et soir pendant {duree} jours',
      '1 cp par jour pendant {duree} jours',
    ],
    GÉLULE: [
      '1 gél matin et soir pendant {duree} jours',
      '1 gél matin, midi et soir pendant {duree} jours',
      '2 gél matin et soir pendant {duree} jours',
      '1 gél par jour pendant {duree} jours',
    ],
    CAPSULE: [
      '1 caps matin et soir pendant {duree} jours',
      '1 caps matin, midi et soir pendant {duree} jours',
      '1 caps par jour pendant {duree} jours',
    ],
    SIROP: [
      '5 ml matin, midi et soir pendant {duree} jours',
      '10 ml matin et soir pendant {duree} jours',
      '5 ml matin et soir pendant {duree} jours',
      '2,5 ml 3 fois par jour pendant {duree} jours',
    ],
    SACHET: [
      '1 sachet matin, midi et soir pendant {duree} jours',
      '1 sachet matin et soir pendant {duree} jours',
      '1 sachet par jour pendant {duree} jours',
    ],
    SUPPOSITOIRE: [
      '1 supp matin et soir pendant {duree} jours',
      '1 supp 3 fois par jour pendant {duree} jours',
      '1 supp le soir au coucher pendant {duree} jours',
    ],
    INJECTION: [
      '1 inj IM par jour pendant {duree} jours',
      '1 inj IV matin et soir pendant {duree} jours',
      '1 inj SC par jour pendant {duree} jours',
    ],
    COLLYRE: [
      '1 goutte dans chaque œil 3 fois/j pendant {duree} jours',
      "2 gouttes dans l'œil atteint matin et soir pendant {duree} jours",
      '1 goutte dans chaque œil matin et soir pendant {duree} jours',
    ],
    POMMADE: [
      'Appliquer en couche mince 2 fois/j pendant {duree} jours',
      'Appliquer matin et soir sur la zone atteinte pendant {duree} jours',
    ],
    CRÈME: [
      'Appliquer en couche mince 2 fois/j pendant {duree} jours',
      'Appliquer matin et soir sur la zone atteinte pendant {duree} jours',
    ],
    PATCH: [
      '1 patch toutes les 24h pendant {duree} jours',
      '1 patch toutes les 72h pendant {duree} jours',
    ],
    SUSPENSION: [
      '5 ml matin, midi et soir pendant {duree} jours',
      '10 ml matin et soir pendant {duree} jours',
    ],
    GOUTTE: [
      '5 gouttes 3 fois/j pendant {duree} jours',
      '10 gouttes matin et soir pendant {duree} jours',
    ],
    SPRAY: [
      '2 pulvérisations dans chaque narine matin et soir pendant {duree} jours',
      '1 pulvérisation 3 fois/j pendant {duree} jours',
    ],
  };

  openPosologieSuggestions(): void {
    const forme = (
      this.selectedMedoc?.forme_medicament_libelle || ''
    ).toUpperCase();
    const duree = this.itemToAdd?.duree || 'X';
    const key =
      Object.keys(this.POSOLOGIE_MAP).find((k) => forme.includes(k)) || '';
    const templates = this.POSOLOGIE_MAP[key] || [
      `1 prise matin et soir pendant ${duree} jours`,
      `1 prise 3 fois par jour pendant ${duree} jours`,
    ];
    this.posologieSuggestions = templates.map((t) => ({
      text: t.replace(/{duree}/g, duree),
    }));
    this.selectedSuggestionText = '';
    this.showPosologieSuggestions = true;
  }
  posologie: string = '';
  frequence: string = '';
  renouvellement: string = '';
  quantite: number = 1;
  items: any = [];
  selectedMedoc: any = {};
  dossierActif: any = {};
  prestationActive: any = {};
  itemsMedicament: any = [];
  is_affection_valid = false;

  isLoading: boolean | undefined;
  input_value: any;
  input_option = 'MAT';
  searchPlaceHolder = 'Entrez numéro matricule';

  user: any = {};
  isConsultationSuccess = false;
  itemConsultation: any = {};
  itemToAdd: any = {};
  itemToSave: any = {};
  itemsModePrescription = [
    { code: 'produit', libelle: 'Produit' },
    { code: 'molecule', libelle: 'Molécule' },
  ];
  // model: NgbDateStruct | undefined;
  itemBeneficiare: any = {};
  fileName1: any;
  currentFile: any;
  itemsAffection: any;
  itemsPrescription: any;
  selectedConsultation: any;
  beneficiaireAutOselect: any;
  itemsGarantie: any;
  itemsPraticien: any[] = [];
  latitude: number | null = null;
  longitude: number | null = null;
  selectedAffection: any = {};
  constructor(
    private restClient: RestClientService,
    private router: Router,
    private authService: AuthService,
    private utilities: UtilitiesService,
  ) {
    this.user = this.authService.getCurrentUser();
    console.log('connected user: ', this.user);
    this.itemToAdd = {};
    this.itemToSave.mode_prescription = 'produit';
    // this.getItemsAffection()
    this.itemToSave.date_prescription = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1, // getMonth() returns 0-11
      day: new Date().getDate(),
    };
    // let activeBeneficiaire = this.authService.getActiveBeneficiaire()
    // if (activeBeneficiaire.matricule) {
    //   this.searcheBenef(activeBeneficiaire.matricule)
    // }

    this.beneficiaireAutOselect = this.authService.getActiveBeneficiaire();

    this.getItemsGarantie();
    this.getItemsPraticien();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          console.log('Captured Lat:', this.latitude, 'Lng:', this.longitude);
          let pos = { latitude: this.latitude, longitude: this.longitude };
          this.authService.setUserPosition(pos);
        },
        (error) => {
          console.error('Error capturing location:', error);
        },
      );
    } else {
      console.error('Geolocation not supported by this browser.');
    }
  }

  getItemsAffection() {
    let request = {
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('affection/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsAffection = res.items;
          console.log('this.itemsAffection: ', this.itemsAffection);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsAffection = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsAffection = [];
      },
    );
  }

  onSelectTab(tab: string) {
    this.selectedTab = tab;
  }

  onChangeInputMode() {
    this.input_value = '';
    this.searchPlaceHolder =
      this.input_option == 'MAT'
        ? 'Entrez numéro matricule'
        : 'Entrez numéro cnam';
  }

  getItemsPrescriptionActive() {
    if (!this.itemsGarantie || !this.itemsGarantie.length) return;
    let garantie_id =
      this.itemsGarantie.find((ig: any) => ig.codification == 'CONS')?.id ??
      null;
    if (!garantie_id) return;
    if (!this.itemBeneficiare.id) return;

    this.selectedConsultation = {};
    let request = {
      index: 0,
      size: 1000,
      type_prescription: 'ORDONNANCE',
      data: {
        matricule: this.itemBeneficiare.matricule,
        beneficiaire_id: this.itemBeneficiare.id,
        prestataire_id: this.user.prestataire_id,
        garantie_id: garantie_id,
        is_factured: 0,
        is_hospit: 0,
      },
    };

    this.restClient.post('prestationActe/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsPrescription = res.items;
          this.itemsPrescription = this.itemsPrescription.filter(
            (it: any) =>
              it.count_pharma_non_hospit == 0 &&
              !it.is_expired &&
              !it.is_factured,
          );
          console.log('this.itemsPrescription: ', this.itemsPrescription);
          if (this.itemsPrescription && this.itemsPrescription.length) {
            this.itemsPrescription.map((ip: any) => {
              ip.is_active = false;
            });
          }
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsPrescription = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsPrescription = [];
      },
    );
  }

  check_affection() {
    let request = {
      data: {
        matricule: this.itemBeneficiare.matricule,
        beneficiaire_id: this.itemBeneficiare.id,
        prestataire_id: this.user.prestataire_id,
        affection_id: this.selectedAffection.id,
      },
    };

    this.restClient.post('affection/checkEligibiliy', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError']) {
          this.is_affection_valid = true;
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.is_affection_valid = false;
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.is_affection_valid = false;
      },
    );
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.fileName1 = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        // this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentFile = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  onGetDossiers() {}

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  confirmSaveItem(data: any) {
    // item.specialiteId = this.selectedSpecialite.id
    if (!data || !data.affection_id) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner affection',
        'error',
      );
      return;
    }
    if (!data || !data.date_prescription) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner date prescription',
        'error',
      );
      return;
    }
    if (!data || !data.affection_id) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner affection',
        'error',
      );
      return;
    }
    if (!data || !data.mode_prescription) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner mode prescription',
        'error',
      );
      return;
    }
    if (!this.itemsMedicament || !this.itemsMedicament.length) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner au moin un medicament',
        'error',
      );
      return;
    }

    // Vérifier les champs de renouvellement pour les médicaments marqués renouvelables
    const renewIncomplete = this.itemsMedicament.filter(
      (im: any) =>
        (im.is_renewable == 1 || im.is_renewable === '1') &&
        (!im.frequence_renew ||
          parseFloat(im.frequence_renew) <= 0 ||
          !im.duree_renew ||
          parseFloat(im.duree_renew) <= 0 ||
          !im.quantite_renew ||
          parseFloat(im.quantite_renew) <= 0),
    );
    if (renewIncomplete.length) {
      const names = renewIncomplete
        .map((im: any) => im.medicament_libelle)
        .join(', ');
      this.utilities.showSweetNotification(
        `Champs de renouvellement incomplets pour : ${names}. Veuillez renseigner Fréquence, Durée et Quantité.`,
        'error',
      );
      return;
    }

    const renewInvalid = this.itemsMedicament.filter(
      (im: any) =>
        (im.is_renewable == 1 || im.is_renewable === '1') &&
        parseFloat(im.duree_renew) <= parseFloat(im.frequence_renew),
    );
    if (renewInvalid.length) {
      const names = renewInvalid
        .map((im: any) => im.medicament_libelle)
        .join(', ');
      this.utilities.showSweetNotification(
        `Pour : ${names} — la durée de renouvellement doit être supérieure à la fréquence.`,
        'error',
      );
      return;
    }

    const renewQtyExceeded = this.itemsMedicament.filter(
      (im: any) =>
        (im.is_renewable == 1 || im.is_renewable === '1') &&
        parseFloat(im.quantite_renew) > parseFloat(im.quantite),
    );
    if (renewQtyExceeded.length) {
      const names = renewQtyExceeded
        .map((im: any) => im.medicament_libelle)
        .join(', ');
      this.utilities.showSweetNotification(
        `Pour : ${names} — la quantité à renouveler ne peut pas dépasser la quantité prescrite.`,
        'error',
      );
      return;
    }

    Swal.fire({
      title: 'Prescription de médicament',
      text: 'Souhaitez-vous poursuivre cette action?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.saveItems();
      }
    });
  }

  saveItems() {
    this.isConsultationSuccess = false;

    let file_data = '';
    if (this.currentFile && Object.keys(this.currentFile).length) {
      file_data = this.currentFile;
    }

    if (this.itemsMedicament && this.itemsMedicament.length) {
      this.itemsMedicament.map((im: any) => {
        im.affection_id = this.itemToSave.affection_id;
        im.date_presription = this.itemToSave.date_presription;
        ((im.mode_prescription = this.itemToSave.mode_prescription),
          (im.matricule = this.itemBeneficiare.matricule),
          (im.garantie_id = this.itemsGarantie.find(
            (itg: any) => itg.codification == 'PHARMA',
          ).id),
          (im.beneficiaire_id = this.itemBeneficiare.id),
          (im.affection_id = this.itemToSave.affection_id));
        im.prestation_id = this.selectedConsultation.id;
        im.dossier_id = this.selectedConsultation.dossier_id;
        im.libelle = im.medicament_libelle;
        im.prestation_acte_id = this.selectedConsultation.id;
        im.prestataire_id = this.user.prestataire_id;
        im.praticien_id = this.itemToSave.praticien_id;
        ((im.is_factured = false), (im.latitude = this.latitude));
        im.longitude = this.longitude;
        if (im.is_renewable) {
          const frequence = parseFloat(im.frequence_renew) || 0;
          const duree = parseFloat(im.duree_renew) || 0;

          im.total_renew_done = 0;

          if (frequence > 0) {
            im.total_renew_possible = Math.floor(duree / frequence);
          } else {
            im.total_renew_possible = 0;
          }

          im.total_renew_remaining = im.total_renew_possible;

          // next_renew_date = today + frequence
          if (frequence > 0) {
            const today = new Date();
            const nextDate = new Date(today);
            nextDate.setDate(
              today.getDate() + frequence * (im.total_renew_done + 1),
            );
            im.next_renew_date = nextDate.toISOString().split('T')[0];

            // Liste de toutes les dates de renouvellement
            const baseDate = new Date();
            im.renouvellements = Array.from(
              { length: im.total_renew_possible },
              (_, k) => {
                const d = new Date(baseDate);
                d.setDate(baseDate.getDate() + frequence * (k + 1));
                return d.toISOString().split('T')[0];
              },
            );
          }
        }
      });
    }

    if (this.currentFile && Object.keys(this.currentFile).length) {
      this.itemConsultation.file_data = this.currentFile;
    }

    let request = {
      file_data:
        this.currentFile && Object.keys(this.currentFile).length
          ? this.currentFile
          : '',
      datas: [...this.itemsMedicament],
    };
    request.datas.forEach((d: any) => { d.prestataire_id = this.user.prestataire_id; });

    this.restClient.post('prescriptionActe/create', request).subscribe(
      (res: any) => {
        // this.isLoading = false;
        if (res && !res['hasError']) {
          this.isConsultationSuccess = true;
          this.utilities.showSweetNotification(
            res['status']['message'],
            'succes',
          );
          this.itemsMedicament = [];
          // this.goNext()
          this.getItemsPrescriptionActive();
        } else {
          this.isConsultationSuccess = false;
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
        }
        this.onClosePrescriptionMedocModal.emit('hide');
      },
      (error) => {
        this.isConsultationSuccess = false;
        this.utilities.showSweetNotification(error, 'error');
      },
    );
  }

  getItemsPraticien() {
    let request = { index: 0, size: 1000, data: {} };
    this.restClient.post('praticien/searchByPrestataire', request).subscribe(
      (res: any) => {
        if (res && !res['hasError'] && res['items']) {
          this.itemsPraticien = res.items.map((ip: any) => ({
            ...ip,
            full_name: `${ip.nom} ${ip.prenom} (${ip.specialite_libelle})`
          }));
        } else {
          this.itemsPraticien = [];
        }
      },
      () => { this.itemsPraticien = []; }
    );
  }

  getItemsGarantie() {
    let request = {
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('garantie/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsGarantie = res.items;
          console.log('this.itemsGarantie: ', this.itemsGarantie);
          // // this.getItemsActe()

          // this.itemConsultation.raison_consultation_id =
          //   this.itemsGarantie[0].id;
          this.getItemsPrescriptionActive();
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsGarantie = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsGarantie = [];
      },
    );
  }

  addMedicament(): void {
    if (!this.selectedMedoc || !this.selectedMedoc.id) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner le médicament',
        'error',
      );
      return;
    }
    if (!this.itemToAdd.quantite) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner la quantité',
        'error',
      );
      return;
    }
    if (!this.itemToAdd.posologie) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner la posologie',
        'error',
      );
      return;
    }
    if (!this.itemToAdd.duree) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner la durée',
        'error',
      );
      return;
    }

    if (this.itemsMedicament && this.itemsMedicament.length) {
      let isExist = this.itemsMedicament.filter(
        (ie: any) => ie.medicament_id == this.selectedMedoc.id,
      ).length;
      if (isExist) {
        this.utilities.showSweetNotification(
          'Cet élément est dejà dans la liste',
          'error',
        );
        return;
      }
    }

    let obj = {
      is_entente_prealable: this.selectedMedoc.is_entente_prealable,
      is_exclu: this.selectedMedoc.is_exclu,
      medicament_id: this.selectedMedoc.id,
      medicament_libelle: this.selectedMedoc.libelle,
      forme_medicament_libelle: this.selectedMedoc.forme_medicament_libelle,
      posologie: this.itemToAdd.posologie,
      duree: this.itemToAdd.duree,
      // is_renewable: 0,
      is_renewable: this.itemToAdd.is_renewable || false,
      quantite_renew: this.itemToAdd.quantite_renew || 0,
      is_consultation_required_renew:
        this.itemToAdd.is_consultation_required_renew || false,
      frequence_renew: this.itemToAdd.frequence_renew,
      dure_renew: this.itemToAdd.dure_renew || 0,
      quantite: this.itemToAdd.quantite,
    };

    console.log('obj: ', obj);
    this.itemsMedicament.unshift({ ...obj });
    this.clearText = true;
    this.reload = !this.reload;
    // this.itemToAdd = { quantite: 1 }
    this.itemToAdd = {};
    this.selectedMedoc = {};

    // Force value to change so ngOnChanges() is triggered
    this.cancelItemSelected = false;
    setTimeout(() => {
      this.cancelItemSelected = true;
    }, 0);
  }

  onSelectRow(item: any): void {
    // if (this.isExpired(item.date_expiration)) return;
    this.selectedConsultation = { ...item };
    if (item.is_expired) return;

    this.itemsPrescription.forEach((p: any) => (p.is_active = false));
    item.is_active = true;
    console.log('Selected prescription: ', item);
  }

  isExpired(expirationDate: string | Date): boolean {
    if (!expirationDate) return false; // Handle cases with no expiration date

    const expDate = new Date(expirationDate);
    const today = new Date();

    // Compare dates (ignoring time)
    return expDate.setHours(0, 0, 0, 0) > today.setHours(0, 0, 0, 0);
  }

  onSelectMedoc(event: any) {
    console.log('current medoc', event);
    this.selectedMedoc = event || {};
  }
  onSelectMedocPro(event: any) {
    console.log('current medoc', event);
    this.selectedMedoc = event || {};
  }
  onSelectAffection(event: any) {
    console.log('Hello: ', event.id);
    // console.log("Hello: ",event)
    if (!event) return;
    this.is_affection_valid = false;
    console.log('current aff', event);
    this.selectedAffection = event;
    this.itemToSave.affection_id = event.id;
    this.check_affection();
  }

  goNext() {
    this.onGoToTab.emit('pharmacie');
  }

  removeItem(index: number): void {
    if (confirm('Êtes-vous sûr de vouloir supprimer cet élément?')) {
      this.itemsMedicament.splice(index, 1);
    }
  }

  //   onSetUserInfo(event:any){
  //   if(event.id){
  //     this.itemBeneficiare=event
  //     this.getItemsPrescriptionActive()
  //   }

  // }

  onSetUserInfo(event: any) {
    if (event.id) {
      this.itemBeneficiare = event;
      this.authService.setActiveBeneficiaire(event);
      this.itemConsultation = {};
      this.beneficiaireAutOselect = this.itemBeneficiare;
      this.getItemsPrescriptionActive();
    } else {
      this.authService.setActiveBeneficiaire({});
      this.beneficiaireAutOselect = {};
    }
  }
}
